import type { IconSvgElement } from '@hugeicons/react';

const filledIconCache = new WeakMap<IconSvgElement, IconSvgElement>();

/** Stroke free icons → filled variant for active nav states. */
export function createFilledIcon(icon: IconSvgElement): IconSvgElement {
  return icon.map(([tag, attrs]) => {
    const next = { ...attrs } as Record<string, string | number>;

    delete next.stroke;
    delete next.strokeWidth;
    delete next.strokeLinecap;
    delete next.strokeLinejoin;

    if (!next.fill || next.fill === 'none') {
      next.fill = 'currentColor';
    }

    return [tag, next] as const;
  }) as IconSvgElement;
}

export function getFilledIcon(icon: IconSvgElement): IconSvgElement {
  const cached = filledIconCache.get(icon);
  if (cached) return cached;

  const filled = createFilledIcon(icon);
  filledIconCache.set(icon, filled);
  return filled;
}
